export default __webpack_public_path__ + "static/Dashboard-4@2x-0ec9784fcfd65b4c115563e3b4a599c9.svg";